import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import SpotifyAppForm from "./SpotifyAppForm";
import React, {useContext, useState} from "react";
import {InputText} from "primereact/inputtext";
import {UserService} from "../services/UserService";
import {MainPageContext} from "./MainPage";
import {AuthContext} from "../App";

export default function SpotifyApps({spotifyApps, setSpotifyApps}) {
    const [expandedRows, setExpandedRows] = useState(null);
    const [shareAppWith, setShareAppWith] = useState("");
    const userservice = new UserService();
    const auth = useContext(AuthContext);
    const mp = useContext(MainPageContext);

    let emptyApp = {
        id: '',
        displayname: '',
        client_id: '',
        client_secret: ''
    };

    const [appDialog, setAppDialog] = useState(false);
    const [newApp, setNewApp] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const openNew = () => {
        setNewApp(emptyApp);
        setSubmitted(false);
        setAppDialog(true);
    }


    const hideDialog = () => {
        setSubmitted(false);
        setAppDialog(false);
    }

    const editApp = (app) => {
        setNewApp({
            id: app.spotifyapp_id,
            displayname: app.displayname,
            client_id: '',
            client_secret: ''});
        setAppDialog(true);
    }

    const onRowExpand = (event) => {
        //toast.current.show({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
    };

    const onRowCollapse = (event) => {
        //toast.current.show({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
    };

    const allowExpansion = (rowData) => {
        return true; // rowData.spotify_users.length > 0;
    };

    const findIndexById = (id) => {
        let index = -1;
        for (let i = 0; i < spotifyApps.length; i++) {
            if (spotifyApps[i].spotifyapp_id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    const addNewToApps = (isNew, app) => {
        let _apps = [...spotifyApps];
        if(isNew) {
            _apps.push(app);
        } else {
            let i = findIndexById(app.spotifyapp_id);
            _apps[i] = app;
        }
        setSpotifyApps(_apps);
        setAppDialog(false);
        setNewApp(emptyApp);
    };

    const shareAppWithUsername = (spotifyapp_id) => {
        userservice.giveAccessToSpotifyApp(spotifyapp_id, shareAppWith, auth.getAccessToken()).then((res) => {
            if(res.status === 200) {
                mp.mainToast.current.show({severity: 'success', summary: 'Successfully shared your app with ' +shareAppWith})
                setShareAppWith("");
                mp.setLastRefreshTime(Date.now());// force a refresh of the data
            } else {
                res.json().then((data) => {
                    mp.mainToast.current.show({severity: 'error', summary: 'Could not share app with ' +shareAppWith, detail: data?.detail})
                })
            }
        })
    }


    const rowExpansionTemplate = (data) => {
        return (
            <div className="p-3">
                <h5>Spotify Users connected to {data.displayname}</h5>
                <div className="card mb-4">
                    If you want to share you Spotify App Key with a friend on this site, you can give them permission to use your app. Like with your own, you have to add your friend's eMail to the Spotify Developer Dashboard.
                    <div className="flex flex-wrap gap-1 pt-2">
                        <InputText className={""} value={shareAppWith}
                                   onChange={(e) => setShareAppWith(e.target.value)}
                                   placeholder={"Friend's username"}
                                   style={{width: '290px'}}/>
                        <Button label={"Share"} onClick={() => shareAppWithUsername(data.spotifyapp_id)}/>
                    </div>
                </div>
                <DataTable value={data.spotify_users}>
                    <Column field="spotify_name" header="Display Name" sortable></Column>
                    <Column field="spotify_email" header="email"></Column>
                </DataTable>
            </div>
        );
    };
    //<Button icon="pi pi-trash" className="p-button-rounded p-button-warning" onClick={() => confirmDeleteProduct(rowData)} />
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded mr-2" onClick={() => editApp(rowData)} />
            </React.Fragment>
        );
    }


    return(<div>
            <Button label="New" icon="pi pi-plus" className="mr-2" onClick={openNew} />
            <DataTable value={spotifyApps}
                       expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                       onRowExpand={onRowExpand} onRowCollapse={onRowCollapse} rowExpansionTemplate={rowExpansionTemplate}
                       dataKey="spotifyapp_id"
            >
                <Column expander={allowExpansion} style={{ width: '5rem' }} />
                <Column field="displayname" header="Name" sortable> </Column>
                <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '2rem' }}></Column>
            </DataTable>
            <Dialog visible={appDialog} style={{ width: '450px' }} header="Spotify App (Developer Mode)" modal className="p-fluid" onHide={hideDialog}>
                <SpotifyAppForm onSaveApp={addNewToApps} newApp={newApp} />
            </Dialog>
        </div>

    )

}